import { ref, watch } from 'vue';
import { useField } from 'vee-validate';
import { getYupValidationSchema } from '../validations-schema';

export default {
    props: {
        attributesString: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        checked: {
            type: Boolean,
            default: undefined
        },
        required: {
            type: Boolean,
            default: false
        },
        validators: {
            type: Array
        }
    },
    setup(props, { emit }) {
        const checkedState = ref(props.checked);
        const inputElement = ref(null);

        const { meta, errorMessage, handleBlur, handleChange } = useField(() => props.name,
            props.validators ? getYupValidationSchema(props.validators, false, true) : undefined, {
            initialValue: checkedState.value,
            syncVModel: true,
            validateOnValueUpdate: false,
        });

        // detect reset at the form container level
        watch(() => meta.touched, (newTouched, oldTouched) => {
            if (oldTouched && !newTouched) {
                resetCheckedStatus();
            }
        })

        const resetCheckedStatus = () => {
            checkedState.value = props.checked;
            emit('reset');
        };

        // Validation listeners for the input field, active when validateOnValueUpdate is false.
        const validationListeners = {
            blur: evt => handleBlur(evt, true),
            change: handleChange,
        };

        const attributes = ref(props.attributesString ? JSON.parse(props.attributesString) : {});

        const onInputChange = () => {
            checkedState.value = !checkedState.value;
            handleChange(checkedState.value, true);
            emit('input', checkedState.value);
        };

        const onFocus = () => {
            emit('focus');
        };

        const onBlur = () => {
            emit('blur');
        };

        return {
            checkedState,
            attributes,
            errorMessage,
            validationListeners,
            inputElement,
            onInputChange,
            onFocus,
            onBlur
        };
    }
};